import { StreamField } from 'components/staticpages/streamfield'
import styles from './centereddescriptionblock.css'

export type CenteredDescriptionBlockType = {
  heading: string
  description: string
  disclaimer: string
  text_color: string
  background_color: string
  content: Array<Record<string, unknown>>
}

type CenteredDescriptionBlockProps = {
  value: CenteredDescriptionBlockType
}

const CenteredDescriptionBlock = (props: CenteredDescriptionBlockProps): JSX.Element => {
  const {
    value: { heading, description, disclaimer, text_color, background_color, content },
  } = props
  return (
    <div
      className={styles.background}
      style={{
        color: text_color || 'black',
        backgroundColor: background_color || 'transparent',
      }}
    >
      <div className={styles.wrapper}>
        <span className={styles.heading}>{heading}</span>
        <span className={styles.description}>{description}</span>
        {disclaimer && <span className={styles.disclaimer}>{disclaimer}</span>}
      </div>
      {content && content.length > 0 && <div className={styles.otherContent}>{content && <StreamField blocks={content} />}</div>}
    </div>
  )
}

export default CenteredDescriptionBlock
